import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import {
  YouTubeDestinationPlatformData,
  YouTubeVideoCategoryCatalog,
} from "app/js/src/domain/destinations";

/**
 * Clipping Studio destination-tab wrapper around shared YouTube destination settings.
 * Seeds from resolveYouTubePublicationSettings(override, destination defaults),
 * same pattern as Instagram/Facebook (no draftPlatformData dependency).
 */
@Component({
  selector: "evrideo-clipping-studio-youtube-publish-settings",
  templateUrl: "./clipping-studio-youtube-publish-settings.component.html",
  styleUrls: ["./clipping-studio-youtube-publish-settings.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClippingStudioYoutubePublishSettingsComponent {
  @Input({ required: true }) destinationUid!: string;
  @Input({ required: true }) catalog!: YouTubeVideoCategoryCatalog;
  @Input() platformData: YouTubeDestinationPlatformData | null = null;
  @Input() readonly = false;

  @Output() platformDataChange =
    new EventEmitter<YouTubeDestinationPlatformData>();

  onPlatformDataChange(data: YouTubeDestinationPlatformData): void {
    this.platformDataChange.emit(data);
  }
}
